import { getGridHistorySessionId } from './gridHistorySuppress';

let pendingBefore = null;
let pendingSessionId = null;
let commitTimer = null;

export const GRID_HISTORY_COMMIT_DEBOUNCE_MS = 450;

export function getPendingGridHistoryBefore() {
  return pendingBefore;
}

export function getPendingGridHistorySessionId() {
  return pendingSessionId;
}

export function setPendingGridHistoryBefore(snapshot) {
  pendingBefore = snapshot;
  pendingSessionId = getGridHistorySessionId();
}

export function clearPendingGridHistoryBefore() {
  pendingBefore = null;
  pendingSessionId = null;
}

export function getGridHistoryCommitTimer() {
  return commitTimer;
}

export function setGridHistoryCommitTimer(timer) {
  commitTimer = timer;
}

export function cancelPendingGridHistoryCommit() {
  if (commitTimer) {
    clearTimeout(commitTimer);
    commitTimer = null;
  }
  pendingBefore = null;
  pendingSessionId = null;
}

/** True if pending commit still belongs to the current history session. */
export function isPendingGridHistorySessionCurrent() {
  return (
    pendingSessionId != null &&
    pendingSessionId === getGridHistorySessionId()
  );
}
